import { ATS_API_URL } from "../../config";
import baseDataProvider, { httpClient, publicHttpClient } from "../baseDataProvider";
import { getDocumentUploadPath } from "../documentUploadEndpoint";
import { submitApplication } from "./submitApplication";
const API_URL = ATS_API_URL;
const API_URL_DOC = `${API_URL}/applicant`;

// Main create method that routes to specific handlers
const create = async (resource: string, params: any) => {

    if (resource === "submitapplication") {
        return submitApplication(params);
    }

    if (resource == "predefinedmessage") {
        try {
            const SubscriberData: any = localStorage.getItem("RaStore.switchSubscriberName");
            const { data } = JSON.parse(<any>localStorage.getItem("auth")) || {};
            const SubscriberDataJson = JSON.parse(SubscriberData);
            const subscriberId = SubscriberDataJson?.value || data?.subscriberid;
            const raw = JSON.stringify({ ...params.data, subscriberid: subscriberId });

            const { json, headers, status }: any = await httpClient(
                API_URL + `/subscriber/addpredefinedmessages`,
                {
                    method: "POST",
                    body: raw,
                }
            );
            return json;
        } catch (e: any) {
            throw new Error(e.message);
        }
    } else
        if (resource == "predefinedmessageAdmin") {
            try {
                const raw = JSON.stringify({ ...params.data });

                const { json, headers, status }: any = await httpClient(
                    API_URL + `/admin/predefinedmessages`,
                    {
                        method: "POST",
                        body: raw,
                    }
                );


                return json;
            } catch (e: any) {
                throw new Error(e.message);
            }
        } else
            if (resource === "updatereviewdone") {
                try {
                    const raw = JSON.stringify({ ...params.data });
                    const { json, headers, status }: any = await httpClient(
                        API_URL + `/common/updatereviewdone`,
                        {
                            method: "POST",
                            body: raw,
                        }
                    );
                    const r = json;
                    const res = {
                        data: {
                            id: params?.data?.applicationnumber,
                            ...r?.records,
                        },
                    };
                    return res;
                } catch (e: any) {
                    throw new Error(e.message);
                }
            }
    if (resource === "telemetryEvent") {
        try {
            const raw = JSON.stringify({ ...params.data });
            const { json }: any = await httpClient(
                API_URL + `/common/telemetry/events`,
                {
                    method: "POST",
                    body: raw,
                }
            );
            return {
                data: {
                    id:
                        params?.data?.session?.reviewSessionId ||
                        params?.data?.reviewSessionId ||
                        params?.data?.applicationNumber ||
                        1,
                    ...json?.records,
                },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    }
    //revoke
    if (resource === "revoke") {
        try {
            const raw = JSON.stringify({ ...params.data });
            const { json, headers, status }: any = await httpClient(
                API_URL + `/subscriber/revokeLandlord?ID=${params?.data?.ID}`,
                {
                    method: "POST",
                    body: raw,
                }
            );
            const r = json;
            const res = {
                data: {
                    id: params?.data?.ID,
                    ...r?.records,
                },
            };
            return res;
        } catch (e: any) {
            throw new Error(e.message);
        }
    }
    if (resource == "addupdatetermsandcondition") {
        try {
            const raw = JSON.stringify({ ...params.data });
            const { json, headers, status }: any = await httpClient(
                API_URL + `/subscriber/addupdatetermsandcondition`,
                {
                    method: "POST",
                    body: raw,
                }
            );
            const r = json;
            const res = {
                data: {
                    id: 1,
                    ...r?.records,
                },
            };
            return res;
        } catch (e: any) {
            throw new Error(e.message);
        }
    }
    if (resource == "addCustomValidationMessage") {
        try {
            const raw = JSON.stringify({ ...params.data, userRole: params.data.userRole || 'admin' });
            const { json, headers, status }: any = await httpClient(
                API_URL + `/applicant/income/addCustomValidationMessage`,
                {
                    method: "POST",
                    body: raw,
                }
            );
            const r = json;
            const res = {
                data: {
                    id: 1,
                    ...r?.records,
                },
            };
            return res;
        } catch (e: any) {
            throw new Error(e.message);
        }
    } else
        if (resource == "submittermsandconditions") {
            try {
                const raw = JSON.stringify({ ...params.data });
                const { json, headers, status }: any = await httpClient(
                    API_URL + `/subscriber/agreeterms`,
                    {
                        method: "POST",
                        body: raw,
                    }
                );
                const r = json;
                const res = {
                    data: {
                        id: 1,
                        ...r?.records,
                    },
                };
                return res;
            } catch (e: any) {
                throw new Error(e.message);
            }
        } else if (resource == "updatelandlordtandc") {
            try {
                const formdata = new FormData();
                formdata.append("IsTermsAccept", params.data.agreeterms);
                formdata.append("IsTermsResign", "0");
                formdata.append("TermsConditions", params.data.TermsConditions);
                formdata.append("files", params.data.signatureImage)
                // const raw = JSON.stringify({ ...params.data });
                const { json, headers, status }: any = await httpClient(
                    API_URL + `/subscriber/updatelandlordtandc`,
                    {
                        method: "POST",
                        body: formdata,
                    }
                );
                const r = json;
                const res = {
                    data: {
                        id: 1,
                        ...r?.records,
                    },
                };
                return res;
            } catch (e: any) {
                throw new Error(e.message);
            }
        }
    if (resource == "addupdatetermsandcondition_admin") {
        try {
            const raw = JSON.stringify({ ...params.data });
            const { json, headers, status }: any = await httpClient(
                API_URL + '/admin/updatetermsandcondition',
                {
                    method: "POST",
                    body: raw,
                }
            );
            const r = json;
            const res = {
                data: {
                    id: 1,
                    ...r?.records,
                },
            };
            return res;
        } catch (e: any) {
            throw new Error(e.message);
        }
    }

    if (resource == "addSystemNotification") {
        // 
        try {
            const raw = JSON.stringify({ ...params.data, ID: params.data.id || 0 });
            const { json, headers, status }: any = await httpClient(
                API_URL + '/admin/addSystemNotification',
                {
                    method: "POST",
                    body: raw,
                }
            );

            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    }
    if (resource == "addEditAdminResource") {
        // 
        try {
            //const raw = JSON.stringify({ ...params.data,ID: params.data.id || 0 });
            const { json, headers, status }: any = await httpClient(
                API_URL + '/admin/addEditAdminResource',
                {
                    method: "POST",
                    body: params.data,
                }
            );

            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    }

    if (resource == "updateprofiledocumentsettigs") {
        // 
        try {

            const raw = JSON.stringify({ ...params.data });
            const { json, headers, status }: any = await httpClient(
                API_URL + '/subscriber/updateprofiledocumentsettigs',
                {
                    method: "POST",
                    body: raw,
                }
            );

            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    }
    if (resource == "updateprofilesettigs") {
        // 
        try {

            const raw = JSON.stringify({ ...params.data });
            const { json, headers, status }: any = await httpClient(
                API_URL + '/subscriber/updateprofilesettigs',
                {
                    method: "POST",
                    body: raw,
                }
            );

            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    }
    if (resource == "addupdateapplicationprofile") {
        // 
        try {
            const SubscriberData: any = localStorage.getItem("RaStore.switchSubscriberName");
            const { data } = JSON.parse(<any>localStorage.getItem("auth")) || {};
            const SubscriberDataJson = JSON.parse(SubscriberData);
            const subscriberId = SubscriberDataJson?.value || data?.subscriberid;
            const raw = JSON.stringify({ ...params.data, SubscriberID: subscriberId });
            const { json, headers, status }: any = await httpClient(
                API_URL + '/subscriber/addupdateapplicationprofile',
                {
                    method: "POST",
                    body: raw,
                }
            );

            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    }
    if (resource == "getCollectiveListOfPropertyAndOffice") {
        try {
            const raw = JSON.stringify({ ...params.data });
            const { json, headers, status }: any = await httpClient(
                API_URL + '/common/getCollectiveListOfPropertyAndOffice',
                {
                    method: "POST",
                    body: raw,
                }
            );
            const r = json;
            const res = {
                data: {
                    id: 1,
                    ...r?.records,
                },
            };
            return res;
        } catch (e: any) {
            throw new Error(e.message);
        }
    }
    if (resource === "reprocessEmployer") {
        try {
            const raw = JSON.stringify({ ...params.data });
            const { json, headers, status }: any = await httpClient(
                API_URL_DOC + `/income/reprocessEmployer`,
                {
                    method: "POST",
                    body: raw,
                }
            );
            const r = json;
            const res = {
                data: {
                    id: params?.id,
                    ...r?.records,
                },
            };
            return res;
        } catch (e: any) {
            throw new Error(e.message);
        }
    }

    if (resource === "automovedocument") {
        try {
            const applicationDocumentId = String(params?.data?.application_document_id ?? "").trim();
            if (!applicationDocumentId || applicationDocumentId.toLowerCase() === "undefined" || applicationDocumentId.toLowerCase() === "null" || applicationDocumentId === "0") {
                throw new Error("application_document_id is required to move a document");
            }
            const raw = JSON.stringify({ ...params.data });
            const { json, headers, status }: any = await httpClient(
                API_URL + `/admin/automovedocument?application_document_id=${encodeURIComponent(applicationDocumentId)}`,
                {
                    method: "POST",
                    body: raw,
                }
            );
            const r = json;
            const res = {
                data: {
                    id: params?.data?.application_document_id,
                    ...r?.records,
                },
            };
            return res;
        } catch (e: any) {
            throw e;
        }
    }

    if (resource === "getscreeningreport") {
        const { data } = JSON.parse(<any>localStorage.getItem("auth")) || {};


        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("authorization", data?.tokendata || null);

        const raw = JSON.stringify(params.data);

        const requestOptions: any = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };
        try {
            const response = await fetch(
                `${API_URL}/subscriber/getscreeningreport`,
                requestOptions
            );

            if (response.status != 200) {
                const result = await response.json();
                throw new Error(result?.message);
            }
            const result = await response.blob();
            const url = window.URL.createObjectURL(result);

            const a = document.createElement("a");
            a.href = url;
            a.target = "_blank";
            a.click();

            return {
                data: { id: 1 },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    }

    if (resource === "loginFromAdminDashboard") {
        try {
            const raw = JSON.stringify({ ...params.data });
            const { json }: any = await httpClient(
                `${API_URL_DOC}/users/LoginFromAdminDashboard`,
                {
                    method: "POST",
                    body: raw,
                }
            );
            const res = {
                data: {
                    id: 1,
                    ...json,
                },
            };
            return res;
        } catch (e: any) {
            throw new Error(e?.message || "Unable to open the selected application.");
        }
    }

    if (resource === "loginFromAdminDashboardInvitedApp") {
        try {
            const { json, headers, status }: any = await httpClient(`${API_URL}/common/openSentInviteApp`, {
                method: 'POST',
                body: JSON.stringify(params.data),
            });
            return {
                data: { id: 1, ...json }
            };
        } catch (e) {
            throw new Error("Applicant is inactive or not found!");
        }
    }
    if (resource === "mlclassdetails") {
        try {
            const raw = JSON.stringify({ ...params.data });
            const { json }: any = await httpClient(
                `${API_URL_DOC}/ml/mlclassdetails`,
                {
                    method: "POST",
                    body: raw,
                }
            );
            const res = {
                data: {
                    ...json,
                },
            };
            return res;
        } catch (e) {
            throw new Error("something went wrong, try again!");
        }
    }
    if (resource === "generateOtp") {
        try {
            let myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            const raw = JSON.stringify({ ...params.data });
            const result: any = await fetch(API_URL_DOC + "/auth/GenerateOtp", {
                method: "POST",
                body: raw,
                headers: myHeaders,
            });

            const r = await result.json();
            if (r?.success === false) {
                throw new Error(r?.message || "Unable to send verification code");
            }
            const res = {
                data: {
                    id: params.id,
                    message: r?.message,
                    ...r?.records,
                },
            };
            return res;
        } catch (e: any) {
            throw new Error(e.message);
        }
    }
    if (resource === "registrationSendOtp") {
        try {
            const { json }: any = await httpClient(
                `${API_URL_DOC}/users/registration/send-otp`,
                {
                    method: "POST",
                    body: JSON.stringify(params.data),
                }
            );
            return { data: { id: params?.id || 1, ...json } };
        } catch (e: any) {
            throw new Error(e.message);
        }
    }
    if (resource === "registrationVerifyOtp") {
        try {
            const { json }: any = await httpClient(
                `${API_URL_DOC}/users/registration/verify-otp`,
                {
                    method: "POST",
                    body: JSON.stringify(params.data),
                }
            );
            return { data: { id: params?.id || 1, ...json } };
        } catch (e: any) {
            throw new Error(e.message);
        }
    }
    if (resource === "registrationComplete") {
        try {
            const { json }: any = await httpClient(
                `${API_URL_DOC}/users/registration/complete`,
                {
                    method: "POST",
                    body: JSON.stringify(params.data),
                }
            );
            return { data: { id: params?.id || 1, ...json } };
        } catch (e: any) {
            throw new Error(e.message);
        }
    }
    if (resource === "startApplicationRegistration") {
        try {
            const { json }: any = await httpClient(
                `${API_URL_DOC}/users/registration/start-from-dashboard`,
                {
                    method: "POST",
                    body: JSON.stringify(params.data),
                }
            );
            return { data: { id: params?.id || 1, ...json } };
        } catch (e: any) {
            throw new Error(e.message);
        }
    }
    if (resource === "logout") {
        try {
            const { json }: any = await httpClient(API_URL + `/account/logout`, {
                method: "POST",
            });
            const r = json;
            const res = {
                data: {
                    id: params.id,
                    ...r?.records,
                },
            };
            return res;
        } catch (e: any) {
            throw new Error(e.message);
        }
    }
    if (resource === "loginTokenCheckDocupload") {
        try {
            const { data } = JSON.parse(<any>localStorage.getItem("auth")) || {};
            const raw = JSON.stringify({ ...params.data, token: data?.tokendata });
            const { json, headers, status }: any = await httpClient(
                API_URL_DOC + `/auth/superuser`,
                {
                    method: "POST",
                    body: raw,
                }
            );
            const r = json;
            const res = {
                data: {
                    id: params.id,
                    ...r?.records,
                },
            };
            return res;
        } catch (e: any) {
            throw new Error(e.message);
        }
    }
    if (resource == "fileUpload") {
        try {
            const formdata = new FormData();
            formdata.append("trn_id", params?.data?.trn_id);
            for (let i = 0; i < params?.data?.files.length; i++) {
                formdata.append("files[]", params?.data?.files[i]);
            }
            formdata.append("document_id", params?.data?.document_id);
            formdata.append("source_id", params?.data?.source_id);
            formdata.append("allowOfferLetter", params?.data?.allowOfferLetter);
            const uploadPath = getDocumentUploadPath(params?.data?.document_id);
            const { json, headers, status }: any = await httpClient(
                API_URL + uploadPath,
                {
                    method: "POST",
                    body: formdata,
                }
            );
            return { data: { ...params, ...json, id: params?.data?.trn_id } };
        } catch (error: any) {
            throw new Error(error.message);
        }
    }
    if (resource === "income") {
        try {
            const raw = JSON.stringify({ ...params.data });
            const { json, headers, status }: any = await httpClient(
                API_URL_DOC + `/income/addSource`,
                {
                    method: "POST",
                    body: raw,
                }
            );
            const r = json;
            const res = {
                data: {
                    id: params.id,
                    ...r?.records,
                },
            };
            return res;
        } catch (e: any) {
            throw new Error(e.message);
        }
    }
    if (resource === "updateApplicationStatus") {
        try {
            const raw = JSON.stringify({ ...params.data });
            const { json, headers, status }: any = await httpClient(
                API_URL_DOC + `/document/updateApplicationStatus`,
                {
                    method: "POST",
                    body: raw,
                }
            );
            const r = json;
            const res = {
                data: {
                    id: params.data.trn_id,
                    ...r,
                },
            };
            return res;
        } catch (e: any) {
            // ADO 4853: preserve e.body (carries `snapshot` on a failed
            // capture) so callers' onError handlers can distinguish that
            // case from a generic request failure — see DocumentAnalysis's
            // handle_Admin_Submit/handle_Admin_Submit_Next.
            const err: any = new Error(e.message);
            err.body = e.body;
            throw err;
        }
    }
    if (resource === "reportFraudApplicant") {
        try {
            const raw = JSON.stringify(params.data);
            const { json }: any = await httpClient(
                API_URL_DOC + `/riskIndicator/reportFraudSignal`,
                {
                    method: "POST",
                    body: raw,
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            console.error("create: reportFraudApplicant request failed", e?.message || e);
            throw new Error(e.message);
        }
    }

    if (resource == "addcoappcosigner") {
        try {
            const { json }: any = await httpClient(
                `${API_URL}/common/addcoappcosigner`,
                {
                    method: "POST",
                    body: JSON.stringify(params.data),
                }
            );
            const res = json;
            return {
                data: { ...res.data },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    } else if (resource == "sendemailtoapplicant") {
        try {
            const { json }: any = await httpClient(
                `${API_URL}/subscriber/sendemailtoapplicant`,
                {
                    method: "POST",
                    body: JSON.stringify(params.data),
                }
            );
            const res = json;
            return {
                data: {
                    id: 1,
                    success: res?.success,
                    message: res?.message,
                    data: res?.data,
                },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    } else if (resource == "sendsmstoapplicant") {
        try {
            const { json }: any = await httpClient(
                `${API_URL}/subscriber/sendsmstoapplicant`,
                {
                    method: "POST",
                    body: JSON.stringify(params.data),
                }
            );
            const res = json;
            return {
                data: {
                    id: 1,
                    success: res?.success,
                    message: res?.message,
                    data: res?.data,
                },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    } else if (resource == "sendsecondaryapp") {
        try {
            const { json }: any = await httpClient(
                `${API_URL}/subscriber/sendsecondaryapp`,
                {
                    method: "POST",
                    body: JSON.stringify(params.data),
                }
            );
            const res = json;
            return {
                data: { ...res.data },
            };
        } catch (error) {
            throw new Error("something went wrong, try again!");
        }
    } else if (resource == "addnewapplication") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/common/addnewapplication`,
                {
                    method: "POST",
                    body: JSON.stringify(params.data),
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    }
    else if (resource == "mergeApplications") {
        try {
            let output = `NewApplication=${params.data[0]}`; // Start with the NewApplication part

            // Add OldApplication parts
            for (let i = 1; i < params.data.length; i++) {
                output += `&OldApplication=${params.data[i]}`;
            }
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/common/mergeapplication?${output}`,
                {
                    method: "POST",
                    // body: JSON.stringify(params.data),
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    }
    if (resource == "saveVerificationStatus") {
        try {
            const { json, headers, status }: any = await httpClient(
                API_URL_DOC + "/income/saveVerificationStatus",
                {
                    method: "POST",
                    body: JSON.stringify(params.data),
                }
            );

            return {
                data: { id: 1, ...json.data },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    }

    if (resource == "saveSOCRComment") {
        try {
            const raw = JSON.stringify(params.data);
            const { json, headers, status }: any = await httpClient(
                API_URL_DOC + `/document/saveSOCRComment`,
                {
                    method: "POST",
                    body: raw,
                }
            );
            return {
                data: { id: 1, ...json.data },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    }
    if (resource == "addNotes") {
        try {
            const raw = JSON.stringify(params.data);

            const { json, headers, status }: any = await httpClient(
                API_URL + `/subscriber/addNotes`,
                {
                    method: "POST",
                    body: raw,
                }
            );
            return {
                data: { id: 1, ...json.data },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    }

    if (resource == "approvedWithConditions") {

        const { data } = JSON.parse(<any>localStorage.getItem("auth")) || {};

        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("authorization", data?.tokendata || null);

        const raw = JSON.stringify(params.data);

        const requestOptions: any = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };

        try {
            const response = await fetch(
                API_URL +
                `/subscriber/addupdatelandlordadversedecision?subscriberid=${params.data.subscriberid}`,
                requestOptions
            );

            let result;
            if (params.data.IsEmail) {
                result = await response.json();
            } else {
                result = await response.blob();
                const url = window.URL.createObjectURL(result);

                const a = document.createElement("a");
                a.href = url;
                if (params.data.IsPrint) a.target = "_blank";
                else a.download = "docs.pdf"; // Set the desired file name
                a.click();

                // Clean up by revoking the URL object
                window.URL.revokeObjectURL(url);
            }
            return {
                data: {
                    ...params.data,
                    id: 1,
                },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    }
    if (resource == "savedetails") {
        try {
            const raw = JSON.stringify(params.data);
            const { json, headers, status }: any = await httpClient(
                API_URL_DOC + `/contextual/savedetails`,
                {
                    method: "POST",
                    body: raw,
                }
            );
            return {
                data: { id: 1, ...json.data },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    } else if (resource == "resendinvite") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/common/resendinvite`,
                {
                    method: "POST",
                    body: JSON.stringify(params.data),
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    } else if (resource == "shareappreport") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/common/shareappreport`,
                {
                    method: "POST",
                    body: JSON.stringify(params.data),
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    } else if (resource == "resendshareappreport") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/common/resendshareappreport`,
                {
                    method: "POST",
                    body: JSON.stringify(params.data),
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    } else if (resource == "accountLogin") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/account/Login`,
                {
                    method: "POST",
                    body: JSON.stringify(params.data),
                    // headers: {"Content-Type": "application/json"},
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    } else if (resource == "updatenewtagsection") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/common/updatenewtagsection`,
                {
                    method: "POST",
                    body: JSON.stringify(params.data),
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    } else if (resource == "updatenewtagapp") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/common/updatenewtagapp`,
                {
                    method: "POST",
                    body: JSON.stringify(params.data),
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    } else if (resource == "forgotPassword") {
        try {
            const { json, headers, status }: any = await publicHttpClient(
                `${API_URL}/account/forgotPassword`,
                {
                    method: "POST",
                    body: JSON.stringify(params.data),
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    }
    else if (resource == "forgotUsername") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/admin/forgetUsername`,
                {
                    method: "POST",
                    body: JSON.stringify(params.data),
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    }
    else if (resource == "mfa_VerifyOtp") {
        try {
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify(params.data);

            const requestOptions: any = {
                method: "POST",
                headers: myHeaders,
                credentials: "include",
                body: raw,
            };

            const response = await fetch(
                API_URL + "/account/VerifyOtp",
                requestOptions
            );
            // await response.text();
            const result = await response.json();

            if (response.status != 200) {
                throw new Error(result.message);
            }
            return {
                data: {
                    id: 1,
                    ...result,
                },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    } else if (resource == "mfa_sendmfaallotp") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/account/sendmfaallotp`,
                {
                    method: "POST",
                    body: JSON.stringify(params.data),
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    } else if (resource == "mfa_SendMfaEmailOtp") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/account/sendmfaemailotp`,
                {
                    method: "POST",
                    body: JSON.stringify(params.data),
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    } else if (resource == "mfa_sendmfasmsotp") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/account/sendmfasmsotp`,
                {
                    method: "POST",
                    body: JSON.stringify(params.data),
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    } else if (resource == "resetPassword") {
        try {
            const { json, headers, status }: any = await publicHttpClient(
                `${API_URL}/account/resetPassword`,
                {
                    method: "POST",
                    body: JSON.stringify(params.data),
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    }
    //change password for subscriber user setup
    else if (resource == "changePassword") {
        const { data } = JSON.parse(<any>localStorage.getItem("auth")) || {};

        const headers = new Headers();
        headers.append("authorization", data?.tokendata || null);
        headers.append("trn_id", data?.trn_id || null);
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/subscriber/changepassword`,
                {
                    method: "POST",
                    body: JSON.stringify(params.data),
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    }
    else if (resource == "processScreening") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/subscriber/process-screening`,
                {
                    method: "POST",
                    body: params?.data,
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    } else if (resource == "add-property") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/subscriber/add-property`,
                {
                    method: "POST",
                    body: params?.data,
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    } else if (resource == "update-property") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/subscriber/update-property`,
                {
                    method: "PUT",
                    body: params?.data,
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    } else if (resource == "add-floor") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/subscriber/add-floor`,
                {
                    method: "POST",
                    body: JSON.stringify(params?.data),
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    } else if (resource == "update-floor") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/subscriber/update-floor`,
                {
                    method: "PUT",
                    body: JSON.stringify(params?.data),
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    } else if (resource == "add-unit") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/subscriber/add-unit`,
                {
                    method: "POST",
                    body: JSON.stringify(params?.data),
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    }
    if (resource == "saveiddetail") {
        try {
            const raw = JSON.stringify(params.data);
            const { json, headers, status }: any = await httpClient(
                API_URL_DOC + `/applicant/saveiddetail`,
                {
                    method: "POST",
                    body: raw,
                }
            );
            return {
                data: { id: 1, ...json.data },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    }
    if (resource == "savePayment") {
        try {
            const raw = JSON.stringify(params.data);
            const { json, headers, status }: any = await httpClient(
                API_URL_DOC + `/stripe/payment`,
                {
                    method: "POST",
                    body: raw,
                }
            );
            return {
                data: { id: 1, ...json.data },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    }
    if (resource == "savedetails") {
        try {
            const raw = JSON.stringify(params.data);
            const { json, headers, status }: any = await httpClient(
                API_URL_DOC + `/contextual/savedetails`,
                {
                    method: "POST",
                    body: raw,
                }
            );
            return {
                data: { id: 1, ...json.data },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    } else if (resource == "resendinvite") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/common/resendinvite`,
                {
                    method: "POST",
                    body: JSON.stringify(params.data),
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    } else if (resource == "shareappreport") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/common/shareappreport`,
                {
                    method: "POST",
                    body: JSON.stringify(params.data),
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    } else if (resource == "resendshareappreport") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/common/resendshareappreport`,
                {
                    method: "POST",
                    body: JSON.stringify(params.data),
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    } else if (resource == "accountLogin") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/account/Login`,
                {
                    method: "POST",
                    body: JSON.stringify(params.data),
                    // headers: {"Content-Type": "application/json"},
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    } else if (resource == "updatenewtagsection") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/common/updatenewtagsection`,
                {
                    method: "POST",
                    body: JSON.stringify(params.data),
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    } else if (resource == "forgotPassword") {
        try {
            const { json, headers, status }: any = await publicHttpClient(
                `${API_URL}/account/forgotPassword`,
                {
                    method: "POST",
                    body: JSON.stringify(params.data),
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    } else if (resource == "resetPassword") {
        try {
            const { json, headers, status }: any = await publicHttpClient(
                `${API_URL}/account/resetPassword`,
                {
                    method: "POST",
                    body: JSON.stringify(params.data),
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    } else if (resource == "processScreening") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/subscriber/process-screening`,
                {
                    method: "POST",
                    body: params?.data,
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    } else if (resource == "add-property") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/subscriber/add-property`,
                {
                    method: "POST",
                    body: params?.data,
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    } else if (resource == "update-property") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/subscriber/update-property`,
                {
                    method: "PUT",
                    body: params?.data,
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    } else if (resource == "add-floor") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/subscriber/add-floor`,
                {
                    method: "POST",
                    body: JSON.stringify(params?.data),
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    } else if (resource == "update-floor") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/subscriber/update-floor`,
                {
                    method: "PUT",
                    body: JSON.stringify(params?.data),
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    } else if (resource == "add-unit") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/subscriber/add-unit`,
                {
                    method: "POST",
                    body: JSON.stringify(params?.data),
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    }
    else if (resource == "update-template-status") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}` + `/subscriber/enableDisableTemplate`,
                {
                    method: "POST",
                    body: JSON.stringify(params?.data),
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    }
    //for admin manage user
    else if (resource == "setinactive") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}` + `/admin/setinactive`,
                {
                    method: "POST",
                    body: JSON.stringify(params?.data),
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    }
    //for subscriber user setup
    else if (resource == "setinactive-subscriber") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}` + `/subscriber/setinactive`,
                {
                    method: "POST",
                    body: JSON.stringify(params?.data),
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    }
    else if (resource == "update-email-template-details") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}` + `/subscriber/updateEmailTemplateData`,
                {
                    method: "POST",
                    body: JSON.stringify(params?.data),
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    }

    //for admin
    else if (resource == "update-admin-template-status") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}` + `/admin/enableDisableTemplate`,
                {
                    method: "POST",
                    body: JSON.stringify(params?.data),
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    }

    else if (resource == "admin-update-email-template-details") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}` + `/admin/updateEmailTemplateData`,
                {
                    method: "POST",
                    body: JSON.stringify(params?.data),
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    }




    else if (resource == "update-unit") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/subscriber/update-unit`,
                {
                    method: "PUT",
                    body: JSON.stringify(params?.data),
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    } else if (resource == "add-integration-setting-rule") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/subscriber/integration-setting-rule`,
                {
                    method: "POST",
                    body: JSON.stringify(params?.data),
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    } else if (resource == "update-integration-setting-rule") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/subscriber/integration-setting-rule`,
                {
                    method: "PUT",
                    body: JSON.stringify(params?.data),
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    } else if (resource == "add-subscriber") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/subscriber/add-subscriber`,
                {
                    method: "POST",
                    body: params?.data,
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    } else if (resource == "update-subscriber") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/subscriber/update-subscriber`,
                {
                    method: "PUT",
                    body: params?.data,
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    }
    //add admin permission role
    else if (resource == "add-adminRole-permission") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/admin/addrole`,
                {
                    method: "POST",
                    body: JSON.stringify(params?.data),
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    }

    //add update usersetup
    else if (resource == "add-user") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/subscriber/registeruser`,
                {
                    method: "POST",
                    body: JSON.stringify(params?.data),
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    }
    //add schedule report
    else if (resource == "add-schedule-report") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/subscriber/AddUpdateSubscriberReportScheduler`,
                {
                    method: "POST",
                    body: JSON.stringify(params?.data),
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    }

    //preauth quetion
    else if (resource == "addupdatepreauthquestions") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/subscriber/addupdatepreauthquestions`,
                {
                    method: "POST",
                    body: JSON.stringify(params?.data),
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    }

    //add user- for admin user setup
    else if (resource == "add-user-admin-user-setup") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/admin/register`,
                {
                    method: "POST",
                    body: JSON.stringify(params?.data),
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    }

    //add new role of user permission
    else if (resource == "add-role-permission") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/subscriber/addrole`,
                {
                    method: "POST",
                    body: JSON.stringify(params?.data),
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    }
    else if (resource == "subscriber-status") {
        const SubscriberData: any = localStorage.getItem("RaStore.switchSubscriberName");
        const { data } = JSON.parse(<any>localStorage.getItem("auth")) || {};
        const SubscriberDataJson = JSON.parse(SubscriberData);
        const subscriberId = SubscriberDataJson?.value || data?.subscriberid;

        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/subscriber/subscriber-status?subscriberID=${params?.data?.subscriberID || subscriberId}&status=${params?.data?.status}`,
                {
                    method: "PUT",
                    // body: JSON.stringify(params?.data),
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    } else if (resource == "add-hierarchy-levels") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/subscriber/hierarchy-levels`,
                {
                    method: "POST",
                    body: JSON.stringify(params?.data),
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    } else if (resource == "update-hierarchy-levels") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/subscriber/hierarchy-levels`,
                {
                    method: "PUT",
                    body: JSON.stringify(params?.data),
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    } else if (resource == "updateStripeAccount") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/subscriber/addStripe`,
                {
                    method: "PUT",
                    body: JSON.stringify(params?.data),
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    } else if (resource == "add-office") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/subscriber/add-office`,
                {
                    method: "POST",
                    body: params?.data,
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    } else if (resource == "update-office") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/subscriber/update-office`,
                {
                    method: "PUT",
                    body: params?.data,
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    } else if (resource == "import-xls") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/subscriber/import-xls`,
                {
                    method: "POST",
                    body: params?.data,
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            const error: any = new Error(e?.body?.message || e.message);
            error.body = e.body;
            error.status = e.status;
            throw error;
        }
    }
    else if (resource == "import-xls-susbriber-userSetup") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/subscriber/import`,
                {
                    method: "POST",
                    body: params?.data,
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    }
    else if (resource == "sendLeaseDocument") {
        try {
            const { json, headers, status }: any = await httpClient(
                `${API_URL}/applicant/document/sendLeaseDocument?trn_id=${params?.data?.trn_id}&url=${params?.data?.url}`,
                {
                    method: "POST",
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    }
    else if (resource === "retrain") {
        try {
            const raw = JSON.stringify({ ...params.data });
            const { json, headers, status }: any = await httpClient(
                `${API_URL_DOC}/ml/retrain`,
                {
                    method: "POST",
                    body: raw,
                }
            );
            return {
                data: { id: 1, ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    } 
    else if (resource == "plaidBankIncomeLinkToken") {
        try {
            const { json }: any = await httpClient(
                `${API_URL}/plaid/linkToken/bank`,
                {
                    method: "POST",
                    body: JSON.stringify(params.data),
                }
            );
            return {
                data: { ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    } else if (resource == "plaidPayrollIncomeLinkToken") {
        try {
            const { json }: any = await httpClient(
              `${API_URL}/plaid/linkToken/payroll`,
              {
                  method: "POST",
                  body: JSON.stringify(params.data),
              }
            );
            return {
                data: { ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    }
    else if (resource == "plaidPayrollIncomePending") {
        try {
            const { json }: any = await httpClient(
              `${API_URL}/plaid/payrollIncomePending`,
              {
                  method: "POST",
                  body: JSON.stringify(params.data),
              }
            );
            return {
                data: { ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    }
    else if (resource == "plaidBankIncome") {
        try {
            const { json }: any = await httpClient(
                `${API_URL}/plaid/bankIncome`,
                {
                    method: "POST",
                    body: JSON.stringify(params.data),
                }
            );
            return {
                data: { ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    }
    else if (resource == "argylePayrollIncomeLinkToken") {
        try {
            const { json }: any = await httpClient(
                `${API_URL}/argyle/linkToken/payroll`,
                {
                    method: "POST",
                    body: JSON.stringify(params.data),
                }
            );
            return {
                data: { ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    }
    else if (resource == "argylePayrollPending") {
        try {
            const { json }: any = await httpClient(
                `${API_URL}/argyle/payrollPending`,
                {
                    method: "POST",
                    body: JSON.stringify(params.data),
                }
            );
            return {
                data: { ...json },
            };
        } catch (e: any) {
            throw new Error(e.message);
        }
    }
    else if (resource == "argylePayrollAccountRemoved") {
        try {
            const { json }: any = await httpClient(
                `${API_URL}/argyle/payrollAccountRemoved`,
                {
                    method: "POST",
                    body: JSON.stringify(params.data),
                }
            );
            return {
                data: { ...json },
            };
        } catch (e: any) {
            throw e;
        }
    }
    else if (resource == "argyleBankIncomeLinkToken") {
        try {
            const { json }: any = await httpClient(
                `${API_URL}/argyle/linkToken/bank`,
                {
                    method: "POST",
                    body: JSON.stringify(params.data),
                }
            );
            return {
                data: {
                    ...json,
                    id: json?.id || json?.verificationId || json?.sessionId || params?.data?.trn_id || "argyle-bank-link",
                },
            };
        } catch (e: any) {
            throw e;
        }
    }
    else if (resource == "argyleBankFailed") {
        try {
            const { json }: any = await httpClient(
                `${API_URL}/argyle/bankFailed`,
                {
                    method: "POST",
                    body: JSON.stringify(params.data),
                }
            );
            return {
                data: {
                    ...json,
                    id: json?.id || params?.data?.trn_id || "argyle-bank-failed",
                },
            };
        } catch (e: any) {
            throw e;
        }
    }
    else if (resource == "argyleBorrowerFields") {
        try {
            const { json }: any = await httpClient(
                `${API_URL_DOC}/applicant/updateApplicantFields`,
                {
                    method: "POST",
                    body: JSON.stringify(params.data),
                }
            );
            return {
                data: {
                    ...json,
                    id: params?.data?.trn_id || "argyle-borrower-fields",
                },
            };
        } catch (e: any) {
            throw e;
        }
    }
    return baseDataProvider.create(resource, params);
};

export default create;
